export type ConfigurationTutorialModule = 'devices' | 'packages' | 'plans';

export const configurationTutorialEvent = 'cpq:configuration-tutorial:start';

export function startConfigurationTutorial(
  module: ConfigurationTutorialModule,
) {
  window.dispatchEvent(
    new CustomEvent(configurationTutorialEvent, { detail: { module } }),
  );
}
